import { render, staticRenderFns } from "./modifyValidity.vue?vue&type=template&id=9e58937c&"
import script from "./modifyValidity.vue?vue&type=script&lang=js&"
export * from "./modifyValidity.vue?vue&type=script&lang=js&"
import style0 from "./modifyValidity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "modifyValidity.vue"
export default component.exports